<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <geofence-route-list [listType]="DtgListType.list"></geofence-route-list>
    </div>
</div>